import React from 'react';
import { Input } from '@vds/inputs';
import { InHomeUtils } from './../util/inhomeUtils';

export default class PhoneNumber extends React.PureComponent {
    constructor(props) {
        super(props);
        this.inputRef = {};
        this.vds = InHomeUtils.isNotNull(this.props.vds) && this.props.vds && this.props.vds || false;
    }

    keyUpHandler = () => {
        if (this.props.phoneNumberKeyUpHandler) {
            let phoneNumber = null;
            if (this.vds === true) {
                phoneNumber = this.props.valuePh1;
                phoneNumber = phoneNumber.split('-').join("");
            }else {
                phoneNumber = `${this.props.valuePh1}${this.props.valuePh2}${this.props.valuePh3}`;
            }
            
            if (phoneNumber.length === 0 || (phoneNumber.length > 0 && phoneNumber.length < 10)) {
                this.props.phoneNumberKeyUpHandler({ phoneNoErr: "Phone Number should be 10 Digits", isValidTN: false });
            }
            else {
                if (phoneNumber === "0000000000") {
                    this.props.phoneNumberKeyUpHandler({ phoneNoErr: "Please enter Valid Contact #", isValidTN: false });
                }
                else {
                    this.props.phoneNumberKeyUpHandler({ phoneNoErr: "", isValidTN: true });
                }
            }
        }
    }

    removeLastHyphen(value) {
        var n = value.lastIndexOf("-");
        return value.substring(0, n);
    }
    formatPhoneNo(value) {
        var val = value.replace(/[^0-9]/g, '');
        if (value != null && value.length > 0) {          

            var number = val.split('');
            var check = 2;
            val = "";
            for (var count = 0; count < number.length; count++) {
                if (count < 10) {
                    if (count === check) {
                        val = val + number[count] + "-";
                        check = 5;
                    }
                    else
                        val = val + number[count];
                }
            }
            if (val.lastIndexOf('-') > 0 && val.lastIndexOf('-') === (val.length - 1))
                val = this.removeLastHyphen(val);
        }       
        return val;
    }

    isNNumeric = (e) => {
        let keyCode = (e.which) ? e.which : e.keyCode;
        if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode === 8) || (keyCode === 9) || (keyCode === 37) || (keyCode === 39)||(keyCode=== 35)||(keyCode === 36)) {
            return true;
        }
        else {
            e.preventDefault();
            return false;
        }
    }

    onChangeHandler = (e) => {
        let id = e.target.id;
        let currentPos = e.target.selectionStart;
        const targetRef = e.target;
        if (this.vds === true) {
            let id = "ph1";
            //const phoneNumber = e.target.value.split('.').join("");
            const currentDashNo = e.target.value?.split('-').length;
            const ph = this.formatPhoneNo(e.target.value);
            const newDashNo = ph.split('-').length;

            if(newDashNo  > currentDashNo){
                currentPos = currentPos + 1;
            }else if(newDashNo < currentDashNo){
                currentPos = currentPos - 1;
            }
            this.props.updatePhoneNumberState(id, ph);
            setTimeout(() => targetRef?.setSelectionRange(currentPos,currentPos), 0)
            this.props.phoneNumberKeyUpHandler && this.props.phoneNumberKeyUpHandler({ phoneNoErr: "", isValidTN: true });
        } else {
            this.props.updatePhoneNumberState(id, e.target.value);
            if (e.target.value.length === e.target.maxLength) {
                if (this.inputRef[e.target.getAttribute('nextto')] !== null && this.inputRef[e.target.getAttribute('nextto')] !== undefined) {
                    this.inputRef[e.target.getAttribute('nextto')].focus()
                }
            }
        }

    }
    preventCutCopyPasteHandler = (e) => {
        e.preventDefault();
        return false;
    }

    render() {
        //Added to resolve issue#3 Accessibility proddef-29021
        const inputFirst=this.props?.valuePh1?.length??0
        const inputSecond=this.props?.valuePh2?.length??0
        const inputThird=this.props?.valuePh3?.length??0

        const isFiOSFlag = sessionStorage?.getItem('fiosReferralFlow');
        let phoneNumberComp = ([<label htmlFor='ph1'>{!this.props.hideStar && <strong className="required-mark">*</strong>}{this.props.label}</label>, <div className="row margin-left-zero"><input id="ph1"
            name='Phone1'
            autoComplete={isFiOSFlag ? "off" : ''}
            type="tel"
            tabIndex="0"
            className="left w-phone-3 no-required-mark value"
            maxLength="3"
            size="3"
            placeholder="XXX"
            onClick={this.props.onClick}
            onChange={this.onChangeHandler}
            onKeyDown={this.isNNumeric}
            onKeyUp={this.keyUpHandler}
            onBlur={this.keyUpHandler}
            onCut={this.preventCutCopyPasteHandler}
            onCopy={this.preventCutCopyPasteHandler}
            onPaste={this.preventCutCopyPasteHandler}
            value={this.props.valuePh1}
            nextto='ph2'
            ref={(e) => { this.inputRef['ph1'] = e }}
            title='Phone number First three digits'
            aria-label='Phone number First three digits'
            aria-required="true"
            data-cs-mask
            disabled={this.props.disabled} />
            <input id='ph2'
                name='Phone2'
                type="tel"
                tabIndex="0"
                className="left w-phone-3 margin-vert-micro no-required-mark value"
                maxLength="3"
                size="3"
                placeholder="XXX"
                onClick={this.props.onClick}
                autoComplete={isFiOSFlag ? "off" : ''}
                onChange={this.onChangeHandler}
                onKeyDown={this.isNNumeric}
                onKeyUp={this.keyUpHandler}
                onBlur={this.keyUpHandler}
                onCut={this.preventCutCopyPasteHandler}
                onCopy={this.preventCutCopyPasteHandler}
                onPaste={this.preventCutCopyPasteHandler}
                value={this.props.valuePh2}
                nextto='ph3'
                ref={(e) => { this.inputRef['ph2'] = e }}
                title='Phone number Middle three digits'
                aria-label='Phone number Middle three digits'
                aria-required="true"
                data-cs-mask
                disabled={this.props.disabled} />
            <input id='ph3'
                name='Phone3'
                type="tel"
                tabIndex="0"
                className="left w-phone-4 no-required-mark value"
                maxLength="4"
                size="4"
                autoComplete={isFiOSFlag ? "off" : ''}
                placeholder="XXXX"
                onClick={this.props.onClick}
                onChange={this.onChangeHandler}
                onKeyDown={this.isNNumeric}
                onKeyUp={this.keyUpHandler}
                onBlur={this.keyUpHandler}
                onCut={this.preventCutCopyPasteHandler}
                onCopy={this.preventCutCopyPasteHandler}
                onPaste={this.preventCutCopyPasteHandler}
                value={this.props.valuePh3}
                ref={(e) => { this.inputRef['ph3'] = e }}
                title='Phone number Last four digits'
                aria-label='Phone number Last four digits'
                aria-required="true"
                data-cs-mask
                disabled={this.props.disabled} /></div>, <div className={this.props.mtnErr ? "margin-horiz-small text-alert bold" : "hide"} aria-live="assertive">{(inputFirst >= 2 || (inputFirst <= 3 && (inputSecond > 0 || inputThird > 0))) ? "Please enter a valid phone number" : ""}</div>,]);

        if (InHomeUtils.isNotNull(this.props.vds) && this.props.vds && this.props.vds === true) {
            phoneNumberComp = (
                <Input label={this.props.label} type="Phone Number" maxLength="12" id="ph1" data-cs-mask name="phone1" tabIndex="0" onChange={this.onChangeHandler}
                    onKeyDown={this.isNNumeric}
                    // onKeyUp={this.keyUpHandler}
                    onBlur={this.keyUpHandler}
                    autoComplete={isFiOSFlag ? "off" : ''}
                    onClick={this.props.onClick}
                    onCut={this.preventCutCopyPasteHandler}
                    onCopy={this.preventCutCopyPasteHandler}
                    onPaste={this.preventCutCopyPasteHandler}
                    value={this.props.valuePh1}
                    aria-required="true"
                    disabled={this.props.disabled}
                    ref={(e) => { this.inputRef['ph1'] = e }}
                    error={this.props.tnErr? true : false}
                    errorText={this.props.tnErr ? "Please enter a valid phone number" : "You must enter a phone number"}
                />)
        }

        return (
            <React.Fragment>
                {phoneNumberComp}
            </React.Fragment>)
    }
}